import { createApp } from 'vue'
import Tax from './Tax.vue'
import './assets/global.css'

createApp(Tax).mount('#tax')
